import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useDashboardStore } from '../../../store/dashboardStore';
import { GameHeader } from './components/GameHeader';
import { Budget } from './components/Budget';
import { ShoppingList } from './components/ShoppingList';
import { useMoneyGame } from './hooks/useMoneyGame';

export const MoneyManager: React.FC = () => {
  const navigate = useNavigate();
  const { addPoints } = useDashboardStore();
  const {
    budget,
    items,
    cart,
    remainingBudget,
    score,
    gameOver,
    addToCart,
    removeFromCart,
    finishShopping
  } = useMoneyGame();

  const handleGameComplete = () => {
    const bonusPoints = Math.floor(remainingBudget * 2);
    addPoints(score + bonusPoints);
    setTimeout(() => {
      navigate('/dashboard');
    }, 3000);
  };

  return (
    <div className="min-h-screen bg-[#4558C8] text-white p-8">
      <GameHeader score={score} />
      
      <div className="max-w-6xl mx-auto space-y-8 mt-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="grid grid-cols-2 gap-8"
        >
          <Budget 
            totalBudget={budget}
            remainingBudget={remainingBudget}
            onComplete={handleGameComplete}
          />
          
          <ShoppingList
            items={items}
            cart={cart}
            onAddItem={addToCart}
            onRemoveItem={removeFromCart}
            remainingBudget={remainingBudget}
          />
        </motion.div>

        {gameOver && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            className="fixed inset-0 bg-black/50 flex items-center justify-center"
          >
            <div className="bg-white text-[#4558C8] p-8 rounded-2xl text-center">
              <h2 className="text-4xl font-bold mb-4">Art Stand Ready!</h2>
              <p className="text-2xl mb-4">Your art stand is set up perfectly!</p>
              <p className="text-xl mb-2">Budget Remaining: ${remainingBudget.toFixed(2)}</p>
              <p className="text-xl mb-4">Bonus Points: {Math.floor(remainingBudget * 2)}</p>
              <button
                onClick={finishShopping}
                className="bg-[#4558C8] text-white px-8 py-3 rounded-full hover:opacity-90 transition-opacity"
              >
                Open for Business
              </button>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
};